import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

type FileRecord = {
  fileId: string;
  fileName: string;
};

type UploadPayload = {
  caseId: string;
  userId: number;
  file_type: string;
  patientFolderName: string | null;
  uploadedFiles: FileRecord[];
  uploadBy : string
};

type UploadState = {
  loading: boolean;
  success: boolean;
  error: string | null;
  data: any;
};

const initialState: UploadState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

export const postBoxUploadDetails = createAsyncThunk(
  "boxUpload/postDetails",
  async (payload: UploadPayload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/api/box/upload-details`,
        payload
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to upload details"
      );
    }
  }
);

/** FZ only — register selected file names as patients (no Box upload). */
export const postFzClientFileNames = createAsyncThunk(
  "boxUpload/postFzClientNames",
  async (
    payload: {
      caseId: string;
      fileNames: string[];
      createdBy: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.post(`/api/box/fz-client-names`, payload);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add FZ patient names"
      );
    }
  }
);

const boxUploadSlice = createSlice({
  name: "boxUpload",
  initialState,
  reducers: {
    resetBoxUploadState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(postBoxUploadDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(postBoxUploadDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(postBoxUploadDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  },
});

export const { resetBoxUploadState } = boxUploadSlice.actions;
export default boxUploadSlice.reducer;
